<script>
import { FormatNumber } from "./libraries/formatNumber";
export let CurrentAddon = {};
let CurrentLimit = 1;
let inputValue = 0;
let max = 6;
let section;
let price = 0;
let email_marketing = null;
let info_plan = null;
let inputRangeElement = null;
let main_container = null;
let info_text_container = null;
let selected_element = null;
let selected_addon = {};
let list = [];
export let id = $$props.id ?? null;
export let version = $$props.version ?? null;
export let lang =
  (typeof ComponentSliderEmailMarketing !== "undefined" &&
    ComponentSliderEmailMarketing.lang) ??
  "";
export let interval = $$props.interval ?? "month";
export let onUpdate = function(){};
interval = interval.toLowerCase();
let metadata = tripod_plans;

$: {
  if(inputValue){
    inputRangeElement.style.pointerEvents = "all";
    
    onUpdate({
      selected_addon: selected_addon,
      value: inputValue,
      selected: CurrentLimit,
      list: list,
    });
  }
}


/**Cuando el intervalo cambie*/
function setIntervalPlan() {
  let interval_text = info_plan.querySelector(".interval");
  interval_text.innerText = metadata.lang[interval];
}

$: {
  if (interval || email_marketing !== null) {
    if(info_plan !== null && selected_element !== null){
      setIntervalPlan();
      getBall(selected_element);
    }
  }
}

$: {
  if (inputValue) {
    setBallById(inputValue);
  }
}

function changeInputValue(value){
  let { items } = email_marketing;
    let ball = section.querySelector(`.balls[data-price='${value}']`)
      .dataset.price;

    let pricePosition = items[ball - 1].price;
    let emailPosition = items[ball - 1].limit;
    let inputResults = section.querySelector("input.input-range-selector");
    inputValue = value;
    selected_addon = {
      price: pricePosition,
      limit: emailPosition,
      addonPlan: email_marketing.__id__,
    }
    inputResults.value = btoa(
      JSON.stringify(selected_addon)
    );
}

$: { 
  if (inputValue) {
    changeInputValue(inputValue)
  }
}

function getApiConnection() {
  fetch(`${window.tripod_plans.host}api/getAddons`)
    .then((response) => {
      return response.json();
    })
    .then((response) => {
      let addons = response ?? [];
      email_marketing = addons.find((addon)=> addon.id_plan === "email_marketing") ?? null;
      if (email_marketing === null) {
        console.error("Error al conectar con la API");
        return;
      }
      email_marketing.items.map((item, key) => {

        // set current limit
        try {
          if(item.limit === CurrentAddon.active_addons.email_marketing.limit){
            CurrentLimit = key+1;
          }
        } catch (error) {
          CurrentLimit = 0;
        }

        email_marketing.items[key].prices = {
          month: item.price,
          year: item.price * 12,
        };
      });
      list = email_marketing.items;
      let current_key = 0;
      let search_current = email_marketing.items.find(( item, key )=>{
        if(item.limit === CurrentLimit){
          current_key = key+1;
          return item;
        }
      })

      if(typeof search_current !== "undefined"){
        CurrentLimit = current_key
      }
      
      
      try {
        setTimeout(() => {
          let key = 0;
          key = CurrentLimit;
          selected_element = main_container.querySelector(`.balls[data-item='${key}']`);
        }, 500);
      } catch (error) {
        
      }
      
    });
}

getApiConnection();



function setBallById(id){
  let node = section.querySelector(`.balls[data-item='${id}']`);
  getBall(node);
}

function getBall(node) {
  selected_element = node;
  let position = node.dataset.position;
  let item = node.dataset.item;
  
  function setPositionRange(){
    let nodes = [...section.querySelectorAll(".balls")];
    nodes.map((node) => {
      node.classList.remove("selected");
    });
    node.classList.add("selected");
  }
  setPositionRange();


  let priceElement = info_text_container.querySelector(".price-marketing");
  let suscribersMarketingElement = info_text_container.querySelector(".subscribers-marketing");
  
  let totalPrice = email_marketing.items[position].prices[interval];
  let limit = email_marketing.items[position].limit;
  
  priceElement.innerText = `${FormatNumber(totalPrice ?? 0, true)}`;
  suscribersMarketingElement.innerText = `${FormatNumber(limit ?? 0, false)}`;

  
  changeInputValue(+(item))
}
</script>

{#if email_marketing !== null}
  <div class="wrapper {version}" bind:this="{main_container}">
    <section class="section-content">
      <div class="container-email" bind:this={price}>
        <i class="icon-tripod-email-alt has-text-primary font-size-32"></i>
        <div class="info" bind:this={info_plan}>
          <p>
            <span class="info_text_container font-size-14" bind:this="{info_text_container}">
              {@html lang.benefits}
            </span>
          </p>
        </div>
      </div>
    </section>
    <section bind:this={section} class="section-balls {version}">
      <div class="container-balls ">
        <input type="hidden" class="input-range-selector" value="" />
        <input
          class="range"
          {id}
          type="range"
          bind:value={inputValue}
          bind:this={inputRangeElement}
          min="1"
          {max}
          step="1"
        />

        <div class="container-ball-child">
          {#each email_marketing.items as item, key}
            <!-- svelte-ignore a11y-click-events-have-key-events -->
            <p
              on:click={function () {
                getBall(this);
              }}
              class="ball{key} balls {key === 0 && 'selected'}"
              data-item={key + 1}
              data-limit={item.limit}
              data-price={key + 1}
              data-position={key}
            >
              <span class="limit-span">
                +{FormatNumber(item.limit, false)}
              </span>
              <span class="hiddenSpan"></span>
            </p>
          {/each}
        </div>
      </div>
    </section>
  </div>
{/if}
<style>
  .range{
    background-image: linear-gradient(#EAF1FF,#EAF1FF) !important;
  }
  .wrapper:global(.wrapper.default) {
    height: 8.125rem;
  }
  section {
    margin: 1.25rem 0;
    margin-bottom: 1.75rem;
  }

  .section-balls {
    display: flex;
    justify-content: center;
  }
  .section-balls.recommended .balls:global(.selected span) {
    color: var(--color-primary);
    font-weight: 800;
  }
  .balls {
    content: "";
    position: absolute;
    display: inline-flex;
    top: 0.125rem;
    background-color: #fff;
    border-radius: 0.625rem;
    width: 0.75rem;
    height: 0.75rem;
    border: 0.0187rem solid #e0e7ec;
    justify-content: center;
    cursor: pointer;
  }

  .balls:global(.selected) {
    background: var(--color-primary-gradient);
    transform: scale(1.2);
    border: 0;
  }
  .balls:global(.selected span) {
    color: #344fff;
    font-weight: 600;
  }

  .wrapper.recommended .container-email :global(.price-marketing) {
    color: #EAF1FF;
    font-weight: 700;
    font-size: 0.875rem;
  }
  .wrapper .container-email :global(.subscribers-marketing) {
    font-weight: 500;
    color: #424B54;
    font-size: 0.875rem;
  }
  .wrapper.recommended .container-email :global(.subscribers-marketing) {
    color: #fff;
  }
  .wrapper.recommended .container-email {
    color: #fff;
  }

  .section-balls.recommended .container-balls:global(.container-balls) {
    margin-bottom: 5rem;
  }

  .wrapper.default
    .container-email :global(.subscribers-marketing) {
    font-weight: 500;
    color: #424B54;
    font-size: 0.875rem;
  }

  .wrapper.default .container-email :global(.email) {
    background-color: rgb(52 79 255 / 7%);
  }

  .wrapper.default .container-email :global(.info) {
    color: #424B54;
  }

  .wrapper.default .container-email :global(.bold-marketing) {
    color: #424B54;
  }

  .wrapper.default .container-email :global(.price-marketing) {
    font-weight: bolder;
    font-weight: 500;
    color: #424B54;
    font-size: 14px;
  }

  input {
    -webkit-appearance: none;
    background-color: #EAF1FF;
    border-radius: 10%;
    height: 0.5rem;
    position: absolute;
    top: 0;
    width: 100%;
    border-radius: 20px;
    cursor: pointer;
  }

  input[type="range"]::-webkit-slider-thumb {
    -webkit-appearance: none;
    width: 1.0625rem;
    height: 1.0625rem;
    border-radius: 50%;
    z-index: 10000;
    position: sticky;
  }

  .section-balls.recommended span {
    color: var(--color-black-bis);
  }

  span.limit-span {
    position: relative;
    margin-top: 1rem;
    font-size: 11px;
    color: #aab8c2; 
  }

  .container-balls {
    position: relative;
    width: 15.625rem;
  }
  .container-balls input.range{
    width: 100% !important;
  }
  .container-ball-child {
    position: absolute;
    top: -0.3rem;
  }

  .ball0 {
    left: 0px;
  }

  .ball1 {
    left: 3.125rem;
  }

  .ball2 {
    left: 5.75rem;
  }

  .ball3 {
    left: 8.875rem;
  }

  .ball4 {
    left: 11.75rem;
  }

  .ball5 {
    left: 14.9375rem;
  }

  .container-email {
    display: flex;
    justify-content: flex-start;
    gap: 10px;
    width: 100%;
  }

  .container-email .email {
    background-color: #EAF1FF;
    width: 3.25rem;
    height: 3.25rem;
    border-radius: 50%;
    margin-right: 0.5rem;
  }

  .container-email .info {
    width: 80%;
    font-size: 0.875rem;
    line-height: 1.5625rem;
  }

  .bold-marketing {
    font-weight: 500;
    color: #fff;
    font-size: 0.875rem;
  }

  .email {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .email-icon {
    width: 2.75rem;
    height: 2.75rem;
  }

  .hiddenSpan {
    position: absolute;
    top: -18px;
    z-index: 10000;
    width: 0.75rem;
    height: 0.75rem;
  }
  .wrapper :global(.price-marketing), .wrapper :global(.subscribers-marketing){
    color: var(--color-black-bis) !important; 
  }
</style>
